import React from "react";
import Plans from "./Plans";
import SChecker from "./serverChecker";

const PlansPage = () => {
    return (
        <div className="plansPage">
            <SChecker />
            <Plans/>
        </div>
    );
};

//export default Plans;
export default PlansPage;